export const routesConstant = {
  home: '/',
  about: '',
  emailConfirm: '/email-confirmation',
  signup: {
    success: '/signup-success',
  },
  projectLead: {
    onboarding: '/project-lead-onboarding',
    onboardingFromSettings: '/project-lead-onboarding?fromsettings=1',
    onboardingIsLeadOnly: '/project-lead-onboarding?isleadonly=1',
    onboardingSubscriptionPlan: '/project-lead-onboarding/subscription-plan'
  },
  vendor: {
    onboarding: {
      general: '/vendor-onboarding',
      experience: '/vendor-onboarding/experience',
      generalFromSettings: '/vendor-onboarding?fromsettings=1',
      services: '/vendor-onboarding/services',
      industries: '/vendor-onboarding/industries',
      skills: '/vendor-onboarding/skills',
    },
    profile: (id: string | number = ':id'): string => `/vendors/${id}`,
  },
  projects: {
    home: '/projects',
    detail: (id: string | number = ':id'): string => `/projects/${id}`,
    monthlyReport: (id: string | number = ':id'): string =>
      `/projects/${id}/monthly-report`,
    new: {
      lead: '/projects/new/lead',
      details: '/projects/new/details',
      match: '/projects/new/match',
      confirmation: '/projects/new/confirmation',
    },
    edit: {
      lead: (id: string | number = ':id'): string =>
        `/projects/${id}/lead`,
      details: (id: string | number = ':id'): string =>
        `/projects/${id}/details`,
      match: (id: string | number = ':id'): string =>
        `/projects/${id}/match`,
      confirmation: (id: string | number = ':id'): string =>
        `/projects/${id}/confirmation`,
    },
    editDraft: {
      lead: (id: string | number = ':id'): string =>
        `/projects/edit-draft/${id}/lead`,
      details: (id: string | number = ':id'): string =>
        `/projects/edit-draft/${id}/details`,
      match: (id: string | number = ':id'): string =>
        `/projects/edit-draft/${id}/match`,
      confirmation: (id: string | number = ':id'): string =>
        `/projects/edit-draft/${id}/confirmation`,
    },
    matchedVendor: (projectId: number | string, vendorId: number | string) =>
      `/projects/${projectId}/matched-vendors/${vendorId}`,
    matchedVendors: (id: string | number = ':id'): string =>
      `/projects/${id}/matched-vendors`,
    matchedProject: (
      projectId: number | string = ':id',
      connectionId: number | string = ':id'
    ) => `/projects/${projectId}/matched-project/${connectionId}`,
  },
  dashboard: '/dashboard',
  profile: '/profile',
  messages: '/messages',
  termsOfUse: '/terms-of-use',
  privacyPolicy: '/privacy-policy',
  userSettings: '/user-settings'
};
